import React, { memo, useCallback, useRef } from 'react'

import { Icon, Search as SearchIcon, TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import SearchClearButton from 'Pods/Shared/SearchClearButton/SearchClearButton'

import { NOOP } from 'Utils/stableDefaults'

const searchIconSize = { height: '16px', width: '16px' }
const leadIcon = <Icon notSpaced svgComponent={SearchIcon} color="dark" size={searchIconSize} />

function Search({
  value = '',
  onChange = NOOP,
  placeholder = 'Search',
  clearLabel,
}) {
  const inputRef = useRef(null)

  const handleInputChange = useCallback(
    event => onChange(event.target.value),
    [onChange],
  )

  const handleClear = useCallback(() => onChange(''), [onChange])

  return (
    <TextInput
      ref={inputRef}
      id="community-gallery-search"
      isPilot
      size="medium"
      value={value}
      onChange={handleInputChange}
      placeholder={placeholder}
      leadIcon={leadIcon}
      beforeTrailButton={value ? (
        <SearchClearButton label={clearLabel} onClear={handleClear} inputRef={inputRef} />
      ) : null}
      wrapperClassName="filter-search"
      textInputClassName="filter-search__input"
      className="filter-search__field"
    />
  )
}

Search.propTypes = {
  value: string,
  onChange: func,
  placeholder: string,
  clearLabel: string.isRequired,
}

export default memo(Search)
